import { StringTMap } from '../GeneralTypes';
import {
  MULTISELECT_FILTER_TYPE,
  RANGE_FILTER_TYPE,
  BUCKET_FILTER_TYPE,
  LINK_FILTER_TYPE,
  FilterContentTypes,
} from '../enums';

export type FilterObject = {
  disabled?: boolean;
  filterOn: string;
  filterPrefix?: string;
  filterSuffix?: string;
  name: string;
  itemsToShow?: number;
  rangeMax?: number;
  rangeMin?: number;
  type: string;
  values: Array<FilterValueObject>;
  visibleSearchBox?: string;
  displayHint?: Array<string>;
  boundaryMin?: number;
  boundaryMax?: number;
  filterContentType: FilterContentTypes | null;
  queryParamKey?: string;
  toggleFilterOptions?: boolean;
  isActive?: boolean;
};

export type FilterValueObject = {
  name: string;
  filterKey: string;
  itemCount?: number;
  active: boolean;
  normalizedName?: string;
};

export type FilteredItem = {
  filterKey: string;
  filterKeyName?: string;
  filterOn?: string;
  filterType?: MULTISELECT_FILTER_TYPE | RANGE_FILTER_TYPE | BUCKET_FILTER_TYPE | LINK_FILTER_TYPE;
  filterOnName?: string;
  isActive?: boolean;
};

export type FlattenedActiveFilterType = {
  filterKey?: string;
  filterKeyName?: string;
  filterOn: string;
  filterType: MULTISELECT_FILTER_TYPE | RANGE_FILTER_TYPE | BUCKET_FILTER_TYPE | LINK_FILTER_TYPE;
  filterOnName: string;
  filterPrefix?: string;
  filterSuffix?: string;
  rangeMin?: number;
  rangeMax?: number;
  filterContentType: FilterContentTypes | null;
  queryParamKey?: string;
};

export type FilteredItemWithFilterType = {
  filterType: MULTISELECT_FILTER_TYPE | RANGE_FILTER_TYPE | BUCKET_FILTER_TYPE | LINK_FILTER_TYPE;
  filterContentType: FilterContentTypes | null;
  filterOnName: string;
  values?: Array<FilteredItem>;
  filterPrefix?: string;
  filterSuffix?: string;
  rangeMin?: number;
  rangeMax?: number;
  queryParamKey?: string;
};

export type SetFilterObject = {
  filterType: MULTISELECT_FILTER_TYPE | RANGE_FILTER_TYPE | BUCKET_FILTER_TYPE | LINK_FILTER_TYPE;
  filterContentType: FilterContentTypes | null;
  filterOn: string;
  filterOnName: string;
  filteredItems: Array<FilteredItem>;
  filterDisplayHint?: Array<string>;
  filterPrefix?: string;
  filterSuffix?: string;
  isReset?: boolean;
  multiUpdate?: boolean;
  queryParamKey?: string;
};

export type RemoveFilterObject = {
  filterOn: string;
  queryParamKey?: string;
};

export type ActiveFilters = StringTMap<FilteredItemWithFilterType>;

export type FilterState = {
  activeFilters?: ActiveFilters;
};

export type InStoreFilter = {
  storeId: number;
  storeName: string;
};
